module.exports = __webpack_public_path__ + "270f581d5491c01cc909eaf8505b08b8.pdf";